<template>
    <DataTable :value="tableData" class="p-datatable-sm" :paginator="true" :rows="rowsPerPage" :first="first"
        :totalRecords="totalRecords" :rowsPerPageOptions="[5, 10, 20]" :lazy="true" @page="onPage"
        v-model:selection="SelectedTutorIds" dataKey="_id">
        <template #header>
            <div class="flex flex-wrap justify-content-between">
                <div class="flex flex-column justify-content-center align-items-center py-2">
                </div>
                <div v-if="SelectedTutorIds.length > 0" class="flex justify-content-end align-items-center px-3 gap-2">
                    <span class="font-medium text-sm ">
                        {{ SelectedTutorIds.length }} Selected
                    </span>
                    <Button icon="pi pi-trash" label="" class="p-button-text Caption red-btn" severity="danger"
                        @click="emit('delete-student', SelectedTutorIds)" />
                </div>
            </div>
        </template>
        <Column class="accent-checkbox" selectionMode="multiple" headerStyle="width: 3rem"></Column>
        <Column v-for="(col, index) in columns" :key="index" :field="col.field" :header="col.header"
            :sortable=col.sortable class="whitespace-nowrap" :bodyStyle="{ whiteSpace: 'nowrap' }" />
        <Column field="status" header="Status">
            <template #body="{ data }">
                <Select v-model="data.isActive" :options="data.isActive ? disableOption : enableOption"
                    optionLabel="label" optionValue="value" class="w-full md:w-8rem accent-select" size="small"
                    @change="onStatusChange(data)"><template #value="{ value }">
                        <span>{{ value ? 'Enable' : 'Disable' }}</span>
                    </template></Select>
            </template>
        </Column>
        <Column header="" class="text-right">
            <template #body="{ data }">
                <div class="flex justify-content-end">
                    <Button type="button" icon="pi pi-ellipsis-v" class="p-button-text p-button-rounded p-button-plain"
                        @click="toggleMenu($event, data)" aria-haspopup="true" aria-controls="overlay_menu" />
                    <Menu ref="menu" id="overlay_menu" :model="menuItems" :popup="true">
                        <template #item="{ item, props }">
                            <a v-bind="props.action" :class="item.class">
                                <span v-bind="props.label">{{ item.label }}</span>
                            </a>
                        </template>
                    </Menu>
                </div>
            </template>
        </Column>
        <template #paginatorstart>
            <div class="text-sm Caption">
                Showing {{ tableData.length }} of {{ totalRecords }} records
            </div>
        </template>
        <template #empty>
            <div class="flex align-items-center justify-content-center" style="min-height: calc(100vh - 600px)">
                <div class="text-center">
                    <i class="pi pi-inbox" style="font-size: 2rem; color: var(--surface-400)"></i>
                    <p class="mt-2 text-color-secondary">No Data found</p>
                </div>
            </div>
        </template>
    </DataTable>
</template>
<script setup>
import { ref, defineProps, defineEmits } from "vue";
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Menu from 'primevue/menu';
import Button from 'primevue/button';
import Select from 'primevue/select';
defineProps({
    tableData: null,
    isLoading: Boolean,
    rowsPerPage: Number,
    totalRecords: Number,
    currentPage: Number,
    first: {
        type: Number,
        default: 0
    }
})
const emit = defineEmits(["view-profile", "page-change", "status-change", "delete-student"]);
const SelectedTutorIds = ref([]);
const menu = ref(null);
const selectedRow = ref(null);
const enableOption = [{ label: "Enable", value: true }];
const disableOption = [{ label: "Disable", value: false }];

const columns = [
    { field: 'username', header: 'Name', sortable: false },
    { field: 'startedYear', header: 'Year', sortable: false },
    { field: 'address', header: 'Location', sortable: false },
];
const menuItems = ref([
    {
        label: "View Profile",
        command: () => emit("view-profile", selectedRow.value),
    },
    {
        label: "Delete",
        command: () => {
            const StudentIDs = SelectedTutorIds.value.length > 0 ? SelectedTutorIds.value : [selectedRow.value._id]
            emit("delete-student", StudentIDs)
        },
        class: 'red-menu-item'
    },
]);
const toggleMenu = (event, rowData) => {
    selectedRow.value = rowData;
    menu.value.toggle(event);
};
const onStatusChange = (data) => {
    emit("status-change", data);

};
const onPage = (event) => {
    const page = Math.floor(event.first / event.rows) + 1;
    const limit = event.rows;
    emit("page-change", { page, limit });
}
</script>
<style scoped>
.p-button-text.p-button-rounded.p-button-plain {
    color: var(--black-200);
}

.p-datatable .p-column-header-content {
    justify-content: space-between;
}

.p-select {
    --p-select-sm-font-size: 12px;
    --p-select-color: var(--black-700);
    --p-select-hover-border-color: transparent;
    --p-select-border-color: transparent;
    --p-select-focus-border-color: transparent;
}

.red-menu-item {
    color: #d32f2f !important;
}

.red-menu-item:hover {
    background-color: #ffe6e6 !important;
}

::v-deep(.p-select-sm .p-select-label) {
    padding-left: 0 !important;
    padding-right: 0 !important;
}

::v-deep(.p-select) {
    --p-select-sm-font-size: 12px;
    --p-select-color: var(--black-700);
    --p-select-hover-border-color: transparent;
    --p-select-border-color: transparent;
    --p-select-focus-border-color: transparent;
    --p-select-background: transparent;
}

::v-deep(.p-select-sm .p-select-label) {
    padding-left: 0 !important;
    padding-right: 0 !important;
}

::v-deep(.p-checkbox) {
    --p-checkbox-checked-background: var(--accent-500) !important;
    --p-checkbox-border-color: var(--accent-500) !important;
    --p-checkbox-checked-hover-background: var(--accent-500) !important;
    --p-checkbox-checked-border-color: var(--accent-500) !important;
    --p-checkbox-checked-hover-border-color: var(--accent-500) !important;
}
</style>